webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(42);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(116);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Viewer = __webpack_require__(65);
	
	var _Viewer2 = _interopRequireDefault(_Viewer);
	
	var _Cover = __webpack_require__(66);
	
	var _Cover2 = _interopRequireDefault(_Cover);
	
	var _Source = __webpack_require__(68);
	
	var _Source2 = _interopRequireDefault(_Source);
	
	var _NotFound = __webpack_require__(67);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	__webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '/cover', component: _Cover2.default }, { path: '/source/:id?', component: _Source2.default }, { path: '/404', component: _NotFound2.default }, { path: '*', redirect: '/cover' }]
	});
	
	new _vue2.default({
	  router: router,
	  components: { Viewer: _Viewer2.default }
	}).$mount('viewer');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/github.39589f0.jpeg";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(59)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(133),
	  /* template */
	  __webpack_require__(77),
	  /* scopeId */
	  "data-v-69c4789e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(56)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(134),
	  /* template */
	  __webpack_require__(74),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(45);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkStatus(response) {
	  if (response.status >= 200 && response.status < 300) {
	    return response;
	  } else {
	    var error = new Error(response.statusText);
	    error.response = response;
	    return _promise2.default.reject(error);
	  }
	}
	
	function parseJSON(response) {
	  return response.json();
	}
	function parseText(response) {
	  return response.text();
	}
	
	exports.default = {
	  get: function get(url) {
	    var isJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var host = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ('./solutions/');
	
	    headers = new Headers(headers);
	    var query = [];
	    (0, _keys2.default)(param).forEach(function (item) {
	      query.push(item + '=' + encodeURIComponent(param[item]));
	    });
	    var params = query.length ? '?' + query.join('&') : '';
	    url = host + url + params;
	    var init = {
	      method: 'GET',
	      headers: headers,
	      cache: 'default'
	    };
	    if (isJson) {
	      return fetch(url, init).then(checkStatus).then(parseJSON);
	    } else {
	      return fetch(url, init).then(checkStatus).then(parseText);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(42);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventHub = new _vue2.default();
	exports.default = eventHub;

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/coding.8252634.png";

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAD/h4/MvwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADlJREFUWMPt08ERACAIBDEomvqxBh18EQogn9us+HsJAAAAt0BPfQU8A2YKULKSdQAQmpIBAMBm4AAtdCIhmRB8RAAAAABJRU5ErkJggg=="

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(54)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(126),
	  /* template */
	  __webpack_require__(72),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(60)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(127),
	  /* template */
	  __webpack_require__(78),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(58)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(128),
	  /* template */
	  __webpack_require__(76),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(62)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(129),
	  /* template */
	  __webpack_require__(80),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(55)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(130),
	  /* template */
	  __webpack_require__(73),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(57)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(131),
	  /* template */
	  __webpack_require__(75),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(61)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(132),
	  /* template */
	  __webpack_require__(79),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "viewer"
	    }
	  }, [_c('header-nav'), _vm._v(" "), _c('main', {
	    staticClass: "main fix"
	  }, [_c('transition', [_c('keep-alive', [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "copyright"
	  }, [_vm._v("\n    powerd by "), _c('a', {
	    attrs: {
	      "href": "https://github.com/Ma63d/leetcode-viewer",
	      "target": "_blank"
	    }
	  }, [_vm._v("leetcode-viewer")])])
	}]}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.scriptLoaded) ? _c('article', {
	    directives: [{
	      name: "ds",
	      rawName: "v-ds",
	      value: ({
	        id: _vm.articleId,
	        title: _vm.articleTitle,
	        postId: _vm.postId
	      }),
	      expression: "{id: articleId, title: articleTitle, postId: postId}"
	    }],
	    staticClass: "posts duoshuo",
	    attrs: {
	      "id": "duoshuo-comment"
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('aside', {
	    staticClass: "sidebar",
	    class: {
	      show: _vm.asideShow
	    }
	  }, [_c('nav', [_c('div', {
	    staticClass: "search-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywords),
	      expression: "keywords"
	    }],
	    staticClass: "search",
	    class: [_vm.inputing ? 'active' : ''],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.keywords)
	    },
	    on: {
	      "focus": _vm.focus,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.keywords = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.searchResult.length > 0 && _vm.inputing),
	      expression: "searchResult.length > 0 && inputing"
	    }],
	    staticClass: "no-list-style"
	  }, _vm._l((_vm.searchResult), function(result) {
	    return _c('li', {
	      staticClass: "result-item"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/source/' + result.id
	      }
	    }, [_vm._v(_vm._s(result.id) + " . " + _vm._s(result.title))])], 1)
	  }))]), _vm._v(" "), _c('ul', {
	    staticClass: "nav-link-container"
	  }, [_c('li', {
	    staticClass: "nav-link-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/cover"
	    }
	  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Guide" : "介绍"))])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-link-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/source"
	    }
	  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Source Code" : "源码"))])], 1), _vm._v(" "), (_vm.gitRepoUrl !== null) ? _c('li', {
	    staticClass: "nav-link-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "target": "_blank",
	      "href": _vm.gitRepoUrl
	    }
	  }, [_c('img', {
	    staticClass: "github-logo",
	    attrs: {
	      "src": __webpack_require__(27)
	    }
	  }), _vm._v("git repos")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    staticClass: "question-links-container"
	  }, _vm._l((_vm.problems), function(value, key) {
	    return _c('li', {
	      staticClass: "question-link"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/source/' + key,
	        "exact": ""
	      }
	    }, [_vm._v(_vm._s(key) + "." + _vm._s(_vm.problems[key]['title']))])], 1)
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "mask",
	    on: {
	      "click": function($event) {
	        _vm.asideShow = false
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "top-nav-container"
	  }, [_c('nav', {
	    staticClass: "top-nav"
	  }, [_c('router-link', {
	    staticClass: "vertical-center nav-logo",
	    attrs: {
	      "to": "/source"
	    }
	  }, [_c('img', {
	    staticClass: "logo vertical-center-content",
	    attrs: {
	      "src": __webpack_require__(51),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "brand vertical-center-content"
	  }, [_vm._v("Leetcode Solutions")])]), _vm._v(" "), _c('ul', {
	    staticClass: "nav-link-container"
	  }, [_c('li', {
	    staticClass: "nav-link-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/cover"
	    }
	  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Guide" : "介绍"))])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-link-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/source"
	    }
	  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Source Code" : "源码"))])], 1), _vm._v(" "), (_vm.gitRepoUrl !== null) ? _c('li', {
	    staticClass: "nav-link-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "target": "_blank",
	      "href": _vm.gitRepoUrl
	    }
	  }, [_c('img', {
	    staticClass: "github-logo",
	    attrs: {
	      "src": __webpack_require__(27)
	    }
	  }), _vm._v("git repos")])]) : _vm._e()]), _vm._v(" "), _c('img', {
	    staticClass: "menu-button",
	    attrs: {
	      "src": __webpack_require__(52),
	      "alt": ""
	    },
	    on: {
	      "click": _vm.toggle
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "search-container top"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywords),
	      expression: "keywords"
	    }],
	    staticClass: "search",
	    class: [_vm.inputing ? 'active' : ''],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.keywords)
	    },
	    on: {
	      "focus": _vm.focus,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.keywords = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.searchResult.length > 0 && _vm.inputing),
	      expression: "searchResult.length > 0 && inputing"
	    }],
	    staticClass: "result-list"
	  }, _vm._l((_vm.searchResult), function(result) {
	    return _c('li', {
	      staticClass: "result-item"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/source/' + result.id
	      }
	    }, [_vm._v(_vm._s(result.id) + " . " + _vm._s(result.title))])], 1)
	  }))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tac not-found"
	  }, [_c('span', {
	    staticClass: "not-found-number"
	  }, [_vm._v("404")]), _vm._v(" "), _c('span', {
	    staticClass: "not-found-info"
	  }, [_vm._v("not found")])])
	}]}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line-scale-pulse-out-rapid"
	  }, _vm._l((5), function(n) {
	    return _c('div', {
	      style: ({
	        height: _vm.height + 'px',
	        width: _vm.width + 'px',
	        margin: _vm.margin + 'px'
	      })
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "cover"
	  }, [_c('side-bar', {
	    attrs: {
	      "problems": _vm.problems
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cover-inner"
	  }, [_c('img', {
	    staticClass: "cover-pic",
	    attrs: {
	      "src": __webpack_require__(50)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cover-description"
	  }, [_c('div', {
	    staticClass: "cover-description-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n        "), _c('br'), _vm._v("\n        Leetcode Solutions\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "cover-description-content"
	  }, [_vm._v("\n        " + _vm._s(_vm.language === 'en' ? "This website presents all my accepted Leetcode solutions." :
	    "这个网页呈现了我全部的Leecode解题源码.") + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.language === 'en' ? "I've solved" : "我完成了 ") + "\n        "), _c('pulse-out-loader', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "green"
	  }, [_vm._v(_vm._s(_vm.solved))]), _vm._v(" / "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "green"
	  }, [_vm._v(_vm._s(_vm.total))]), _c('pulse-out-loader', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }), _vm._v("\n        " + _vm._s(_vm.language === 'en' ? "problems" : "道题") + " (" + _vm._s(_vm.language === 'zh' ? "有" : "") + " " + _vm._s(_vm.locked) + " " + _vm._s(_vm.language === 'en' ? "problems for a fee" : "题需要付费") + ").\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.language === 'en' ? "Click" : "") + " "), _c('router-link', {
	    attrs: {
	      "to": "/source"
	    }
	  }, [_vm._v(_vm._s(_vm.language === 'en' ? "here" : "点此"))]), _vm._v(" " + _vm._s(_vm.language === 'en' ? "to see every solution" : "查看每一个解题源码") + ".\n        "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "light"
	  }, [_vm._v("Last updated: "), _c('pulse-out-loader', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "green"
	  }, [_vm._v(_vm._s(_vm.lastUpdatedTime))])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "posts"
	  }, [(_vm.title !== '') ? _c('h1', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.question !== '') ? _c('div', {
	    staticClass: "question",
	    domProps: {
	      "innerHTML": _vm._s(_vm.compiledQuestion)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.post !== '') ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.compiledPost)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.content !== '') ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.compiledContent)
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('side-bar', {
	    attrs: {
	      "problems": _vm.problems
	    }
	  }), _vm._v(" "), _c('post', {
	    attrs: {
	      "content": _vm.content,
	      "question": _vm.question,
	      "title": _vm.title,
	      "post": _vm.post
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.content == ''),
	      expression: "content == ''"
	    }],
	    staticClass: "posts tac loading-container"
	  }, [_c('pulse-out-loader', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "height": 100,
	      "width": 10,
	      "margin": 5
	    }
	  })], 1), _vm._v(" "), (_vm.enableDuoShuo && _vm.duoShuoRunning && _vm.content != '') ? _c('duo-shuo', {
	    attrs: {
	      "articleId": _vm.duoShuoArticleId,
	      "articleTitle": _vm.duoShuoArticleTitle,
	      "postId": _vm.postId
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  inserted: function inserted(el, binding) {
	    var boundFunc = function boundFunc() {
	      duoShuoInit(el, binding.value, boundFunc);
	    };
	    window.addEventListener('scroll', boundFunc);
	  },
	  update: function update(el, _ref) {
	    var value = _ref.value,
	        oldValue = _ref.oldValue;
	
	    if (value.id !== oldValue.id || value.title !== oldValue.title) {
	      duoShuoInit(el, value);
	    }
	  },
	  unbind: function unbind(el) {
	    el.innerHTML = '';
	  }
	};
	
	
	function duoShuoInit(el, value, boundFunction) {
	  console.log(value);
	  el.innerHTML = '';
	  window.duoshuoQuery.sso = {
	    login: '/#/source/' + value.postId,
	    logout: window.location.href
	  };
	  var dom = document.createElement('div');
	  dom.setAttribute('data-thread-key', value.id);
	  dom.setAttribute('data-title', value.title);
	  dom.setAttribute('data-url', window.location.origin + window.location.pathname + '#/source/' + value.postId);
	  window.DUOSHUO.EmbedThread(dom);
	  el.appendChild(dom);
	  if (boundFunction !== undefined) {
	    window.removeEventListener('scroll', boundFunction);
	  }
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(46);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getResultJson: function getResultJson() {
	    return _index2.default.get('result.json');
	  },
	  getQuestion: function getQuestion(path) {
	    return _index2.default.get(path + '/question.md');
	  }
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(46);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getResultJson: function getResultJson() {
	    return _index2.default.get('result.json');
	  },
	  getDbJson: function getDbJson(dirPath) {
	    return _index2.default.get(dirPath + '/db.json');
	  },
	  getQuestionText: function getQuestionText(dirPath) {
	    return _index2.default.get(dirPath + '/question.md', false);
	  },
	  getPostText: function getPostText(dirPath) {
	    return _index2.default.get(dirPath + '/post.md', false);
	  }
	};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'c++': 'cpp',
	  'java': 'java',
	  'c': 'c',
	  'c#': 'cs',
	  'javascript': 'js',
	  'python': 'py',
	  'ruby': 'rb',
	  'swift': 'swift',
	  'go': 'go'
	};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (str, caseSensitive) {
	  if (!caseSensitive) {
	    str = str.toLowerCase();
	  }
	
	  var hash = 1315423911;
	  var i = void 0,
	      ch = void 0;
	  for (i = str.length - 1; i >= 0; i--) {
	    ch = str.charCodeAt(i);
	    hash ^= (hash << 5) + ch + (hash >> 2);
	  }
	
	  return hash & 0x7FFFFFFF;
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.markdown = markdown;
	
	var _marked = __webpack_require__(49);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _highlight2 = __webpack_require__(135);
	
	var _highlight3 = _interopRequireDefault(_highlight2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var languages = ['cpp', 'java', 'c', 'cs', 'js', 'py', 'rb', 'swift', 'go'];
	_highlight3.default.registerLanguage('cpp', __webpack_require__(48));
	_highlight3.default.registerLanguage('java', __webpack_require__(138));
	_highlight3.default.registerLanguage('c', __webpack_require__(48));
	_highlight3.default.registerLanguage('cs', __webpack_require__(136));
	_highlight3.default.registerLanguage('js', __webpack_require__(139));
	_highlight3.default.registerLanguage('py', __webpack_require__(140));
	_highlight3.default.registerLanguage('rb', __webpack_require__(141));
	_highlight3.default.registerLanguage('swift', __webpack_require__(142));
	_highlight3.default.registerLanguage('go', __webpack_require__(137));
	
	_highlight3.default.configure({
	  classPrefix: '' });
	_marked2.default.setOptions({
	  renderer: new _marked2.default.Renderer(),
	  gfm: true,
	  pedantic: false,
	  sanitize: false,
	  tables: true,
	  breaks: true,
	  smartLists: true,
	  smartypants: true,
	  highlight: function highlight(code, lang) {
	    if (!~languages.indexOf(lang)) {
	      return _highlight3.default.highlightAuto(code).value;
	    }
	    return _highlight3.default.highlight(lang, code).value;
	  }
	});
	function markdown(str) {
	  return (0, _marked2.default)(str);
	}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HeaderNav = __webpack_require__(70);
	
	var _HeaderNav2 = _interopRequireDefault(_HeaderNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HeaderNav: _HeaderNav2.default
	  }
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PulseOutLoader = __webpack_require__(28);
	
	var _PulseOutLoader2 = _interopRequireDefault(_PulseOutLoader);
	
	var _SideBar = __webpack_require__(29);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _state = __webpack_require__(14);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _index = __webpack_require__(121);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PulseOutLoader: _PulseOutLoader2.default,
	    SideBar: _SideBar2.default
	  },
	  data: function data() {
	    return {
	      name: ('Encounter') === null ? 'My' : ('Encounter') + '\'s',
	      language: ('en'),
	      total: '',
	      solved: '',
	      locked: '',
	      lastUpdatedTime: '',
	      loading: false,
	      problems: {}
	    };
	  },
	  activated: function activated() {
	    if (_state2.default.solved === undefined) {
	      this.fetchData();
	    } else {
	      this.total = _state2.default.total;
	      this.solved = _state2.default.solved;
	      this.locked = _state2.default.locked;
	      this.lastUpdatedTime = _state2.default.lastUpdatedTime;
	      this.problems = _state2.default.resultJson;
	    }
	  },
	
	  methods: {
	    fetchData: function fetchData() {
	      var _this = this;
	
	      this.loading = true;
	      _index2.default.getResultJson().then(function (data) {
	        _this.total = _state2.default.total = data.total;
	        _this.solved = _state2.default.solved = data.solved;
	        _this.locked = _state2.default.locked = data.locked;
	        _this.lastUpdatedTime = _state2.default.lastUpdatedTime = data.lastUpdatedTime;
	        delete data.total;
	        delete data.solved;
	        delete data.locked;
	        delete data.lastUpdatedTime;
	        _state2.default.resultJson = data;
	        _this.problems = _state2.default.resultJson;
	        _this.loading = false;
	      });
	    }
	  }
	};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(119);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(45);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _state = __webpack_require__(14);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _index = __webpack_require__(122);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Post = __webpack_require__(71);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _SideBar = __webpack_require__(29);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _PulseOutLoader = __webpack_require__(28);
	
	var _PulseOutLoader2 = _interopRequireDefault(_PulseOutLoader);
	
	var _DuoShuo = __webpack_require__(69);
	
	var _DuoShuo2 = _interopRequireDefault(_DuoShuo);
	
	var _hash_code = __webpack_require__(124);
	
	var _hash_code2 = _interopRequireDefault(_hash_code);
	
	var _css_class_lang_map = __webpack_require__(123);
	
	var _css_class_lang_map2 = _interopRequireDefault(_css_class_lang_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Post: _Post2.default,
	    SideBar: _SideBar2.default,
	    PulseOutLoader: _PulseOutLoader2.default,
	    DuoShuo: _DuoShuo2.default
	  },
	  data: function data() {
	    return {
	      problems: {},
	      content: '',
	      question: '',
	      title: '',
	      post: '',
	      enableDuoShuo: (false),
	      duoShuoArticleId: '',
	      postId: '',
	      duoShuoArticleTitle: '',
	      duoShuoRunning: false
	    };
	  },
	  activated: function activated() {
	    this.fetchData();
	  },
	  deactivated: function deactivated() {
	    this.duoShuoRunning = false;
	  },
	
	  watch: {
	    '$route': 'fetchData'
	  },
	  methods: {
	    fetchData: function fetchData() {
	      var _this = this;
	
	      if (/^\/source/.test(this.$route.path)) {
	        if (this.enableDuoShuo && this.$route.query.code !== undefined) {
	          this.duoShuoRunning = false;
	          this.$router.replace('/source/' + this.$route.params.id);
	        }
	        if (_state2.default.resultJson === undefined) {
	          _index2.default.getResultJson().then(function (data) {
	            _state2.default.total = data.total;
	            _state2.default.solved = data.solved;
	            _state2.default.locked = data.locked;
	            _state2.default.lastUpdatedTime = data.lastUpdatedTime;
	            delete data.total;
	            delete data.solved;
	            delete data.locked;
	            delete data.lastUpdatedTime;
	            _state2.default.resultJson = data;
	            _this.problems = data;
	            if (_this.$route.params.id !== undefined) {
	              if (_this.problems[Number(_this.$route.params.id)] === undefined) {
	                _this.$router.replace('/404');
	              } else {
	                _this.fetchContent(_this.problems[Number(_this.$route.params.id)].id, _this.problems[Number(_this.$route.params.id)].title);
	              }
	            } else {
	              for (var num in data) {
	                if (data.hasOwnProperty(num)) {
	                  _this.$router.replace('/source/' + num);
	                  break;
	                }
	              }
	            }
	          }).catch(function (err) {
	            console.error(err);
	            console.error('cannot get result.json! ');
	          });
	        } else {
	          this.problems = _state2.default.resultJson;
	          if (this.$route.params.id !== undefined) {
	            if (this.problems[Number(this.$route.params.id)] === undefined) {
	              this.$router.replace('/404');
	            } else {
	              this.fetchContent(this.problems[Number(this.$route.params.id)].id, this.problems[Number(this.$route.params.id)].title);
	            }
	          } else {
	            for (var num in _state2.default.resultJson) {
	              if (_state2.default.resultJson.hasOwnProperty(num)) {
	                this.$router.replace('/source/' + num);
	                break;
	              }
	            }
	          }
	        }
	      }
	    },
	    fetchContent: function fetchContent(id, title) {
	      var _this2 = this;
	
	      this.postId = id + '';
	      var pureId = id;
	      if (id < 10) {
	        id = '00' + id;
	      } else if (id < 100) {
	        id = '0' + id;
	      } else {
	        id = '' + id;
	      }
	      this.title = '';
	      this.content = '';
	      this.question = '';
	      this.post = '';
	      _promise2.default.all([_index2.default.getQuestionText(id + '.' + title), _index2.default.getDbJson(id + '.' + title)]).then(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            question = _ref2[0],
	            source = _ref2[1];
	
	        var titleWithoutDash = title.split('-').join(' ');
	        _this2.title = pureId + ' . ' + titleWithoutDash;
	        if (_this2.enableDuoShuo) {
	          _this2.duoShuoArticleTitle = _this2.title;
	          _this2.duoShuoArticleId = (0, _hash_code2.default)(_this2.title) + '';
	          _this2.duoShuoRunning = true;
	        }
	        _this2.question = question;
	        (0, _keys2.default)(source).forEach(function (language) {
	          var cssClassOfLang = _css_class_lang_map2.default[language];
	          _this2.content += '```' + cssClassOfLang + '\n' + source[language] + '\n```\n';
	        });
	      });
	      _index2.default.getPostText(id + '.' + title).then(function (post) {
	        _this2.post = post;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _duo_shuo = __webpack_require__(120);
	
	var _duo_shuo2 = _interopRequireDefault(_duo_shuo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      scriptLoaded: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.duoshuoQuery = { short_name: ('your origin') };
	    console.log(('your origin'));
	    var ds = document.createElement('script');
	    ds.type = 'text/javascript';
	    ds.async = true;
	    ds.src = (document.location.protocol === 'https:' ? 'https:' : 'http:') + '//static.duoshuo.com/embed.js';
	    ds.charset = 'UTF-8';
	    ds.onload = function () {
	      _this.scriptLoaded = true;
	    };(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(ds);
	  },
	
	  props: {
	    articleId: {
	      type: String
	    },
	    articleTitle: {
	      type: String
	    },
	    postId: {
	      type: String
	    }
	  },
	  directives: {
	    ds: _duo_shuo2.default
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(14);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _event_hub = __webpack_require__(47);
	
	var _event_hub2 = _interopRequireDefault(_event_hub);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      gitRepoUrl: ('https://github.com/xingbofeng/leetcode-viewer'),
	      language: ('en'),
	      inputing: false,
	      searchResult: [],
	      keywords: ''
	    };
	  },
	
	  methods: {
	    focus: function focus() {
	      this.inputing = true;
	    },
	    blur: function blur() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.inputing = false;
	      }, 200);
	    },
	
	    search: _lodash2.default.throttle(function () {
	      if (_state2.default.resultJson === undefined) {
	        return;
	      } else {
	        if (Number(this.keywords) !== Number(this.keywords)) {
	          this.searchResult = searchWithTitle(this.keywords, _state2.default.resultJson);
	        } else {
	          this.searchResult = searchWithNumber(Number(this.keywords), _state2.default.resultJson);
	        }
	      }
	    }, 200),
	    toggle: function toggle() {
	      _event_hub2.default.$emit('toggle');
	    }
	  },
	  watch: {
	    'keywords': function keywords() {
	      this.search();
	    }
	  }
	};
	
	function searchWithNumber(number, targetObj) {
	  if (targetObj[number] !== undefined) {
	    return [{ id: targetObj[number].id, title: targetObj[number].title }];
	  } else {
	    return [];
	  }
	}
	function searchWithTitle(title, targetObj) {
	  title = title.trim().toLowerCase().replace(/\s+/g, '-');
	  var result = [];
	  for (var id in targetObj) {
	    if (targetObj.hasOwnProperty(id)) {
	      if (~targetObj[id].title.indexOf(title)) {
	        result.push({ id: targetObj[id].id, title: targetObj[id].title.replace(/-/g, ' ') });
	
	        if (result.length > 4) {
	          return result;
	        }
	      }
	    }
	  }
	  return result;
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _markdown = __webpack_require__(125);
	
	exports.default = {
	  props: {
	    content: {
	      type: String
	    },
	    question: {
	      type: String
	    },
	    title: {
	      type: String
	    },
	    post: {
	      type: String
	    }
	  },
	  computed: {
	    compiledContent: function compiledContent() {
	      return (0, _markdown.markdown)(this.content);
	    },
	    compiledQuestion: function compiledQuestion() {
	      return (0, _markdown.markdown)(this.question);
	    },
	    compiledPost: function compiledPost() {
	      return (0, _markdown.markdown)(this.post);
	    }
	  }
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    width: {
	      type: Number,
	      default: 2
	    },
	
	    height: {
	      type: Number,
	      default: 20
	    },
	
	    margin: {
	      type: Number,
	      default: 1
	    }
	  }
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _state = __webpack_require__(14);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _event_hub = __webpack_require__(47);
	
	var _event_hub2 = _interopRequireDefault(_event_hub);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      gitRepoUrl: ('https://github.com/xingbofeng/leetcode-viewer'),
	      language: ('en'),
	      inputing: false,
	      searchResult: [],
	      keywords: '',
	      asideShow: false
	    };
	  },
	
	  created: function created() {
	    _event_hub2.default.$on('toggle', this.toggle);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _event_hub2.default.$off('toggle', this.toggle);
	  },
	  props: {
	    problems: {
	      type: Object,
	      required: true
	    }
	  },
	  methods: {
	    focus: function focus() {
	      this.inputing = true;
	    },
	    blur: function blur() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.inputing = false;
	      }, 200);
	    },
	
	    search: _lodash2.default.throttle(function () {
	      if (_state2.default.resultJson === undefined) {
	        return;
	      } else {
	        if (Number(this.keywords) !== Number(this.keywords)) {
	          this.searchResult = searchWithTitle(this.keywords, _state2.default.resultJson);
	        } else {
	          this.searchResult = searchWithNumber(Number(this.keywords), _state2.default.resultJson);
	        }
	      }
	    }, 200),
	    toggle: function toggle() {
	      this.asideShow = !this.asideShow;
	    }
	  },
	  watch: {
	    'keywords': function keywords() {
	      this.search();
	    }
	  }
	};
	
	function searchWithNumber(number, targetObj) {
	  if (targetObj[number] !== undefined) {
	    return [{ id: targetObj[number].id, title: targetObj[number].title }];
	  } else {
	    return [];
	  }
	}
	function searchWithTitle(title, targetObj) {
	  title = title.trim().toLowerCase().replace(/\s+/g, '-');
	  var result = [];
	  for (var id in targetObj) {
	    if (targetObj.hasOwnProperty(id)) {
	      if (~targetObj[id].title.indexOf(title)) {
	        result.push({ id: targetObj[id].id, title: targetObj[id].title.replace(/-/g, ' ') });
	
	        if (result.length > 4) {
	          return result;
	        }
	      }
	    }
	  }
	  return result;
	}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.4a41be396159ae860b93.js